import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
export function Decision() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-164" data-mp="1r2fyfkyd32fe">
      <div className="mx-auto max-w-3xl" data-id="element-165" data-mp="1r3r0ngc5s24e">
        <SectionHeading kicker="Your purchase, your decision" title="Make an informed decision about your educational resources" data-id="element-166" data-mp="1w0hgc2k1wvpa" />
        <div className="mt-8 space-y-4 text-base text-muted sm:text-lg" data-id="element-167" data-mp="2joik6y6abnyd">
          <p data-id="element-168" data-mp="2oodd179menm2">I want you to understand what you’re purchasing before you make your decision.</p>
          <p data-id="element-169" data-mp="2ap57lwmv6j9f">Your purchase includes the digital educational materials specifically listed on the checkout page.</p>
          <p data-id="element-170" data-mp="2epxlj36olcc1">
            You’ll be able to review the educational references, explore the assessment frameworks, and evaluate
            the documentation templates included in the collection.
          </p>
          <p data-id="element-171" data-mp="13do9d2g2j06u">
            These resources are designed to support professional learning and the organization of educational
            materials. They do not replace appropriate qualifications, supervised training, individualized patient
            assessment, or current professional guidance.
          </p>
        </div>
        <div className="mt-8 flex items-start gap-4 rounded-3xl bg-paper p-6" data-id="element-172" data-mp="ovvhvgi87g8z">
          <ShieldCheckIcon className="h-8 w-8 shrink-0 text-electric" aria-hidden="true" data-id="element-173" data-mp="oxyjyywnkzu2" />
          <p className="text-base text-ink" data-id="element-174" data-mp="12tsjirbjecui">
            <strong data-id="element-175" data-mp="xx21vzk3396z">Refund policy:</strong> Please review the applicable refund eligibility requirements, request
            procedure, and deadline displayed at checkout before purchasing.
          </p>
        </div>

        <TransformCTA headline="Get access to the complete collection" label="Get Access Now" note="One-time payment · $27 USD" data-id="element-176" data-mp="17nekhm8c8sah" />
      </div>
    </section>;
}